/**
 * IAEA Gamma Irradiators layer renderer -- matching Worldmonitor 1:1.
 * Simple ScatterplotLayer with magenta dots.
 *
 * MIT License -- see THIRD-PARTY-NOTICES.md
 */

import { ScatterplotLayer } from '@deck.gl/layers';
import type { Layer } from '@deck.gl/core';
import { GAMMA_IRRADIATORS } from '@/config/data';
import type { GammaIrradiator } from '@/config/data';

/** Layer IDs handled by this renderer. */
export const IRRADIATOR_LAYER_IDS = new Set(['irradiators']);

/** Create deck.gl layers for IAEA irradiator markers. */
export function createIrradiatorLayers(zoom: number): Layer[] {
  if (GAMMA_IRRADIATORS.length === 0) return [];

  void zoom; // zoom available for future progressive disclosure

  return [
    new ScatterplotLayer<GammaIrradiator>({
      id: 'irradiators-layer',
      data: GAMMA_IRRADIATORS,
      getPosition: (d) => [d.lon, d.lat],
      getRadius: 6000,
      getFillColor: [255, 100, 255, 180],  // Magenta -- matching WM
      radiusMinPixels: 4,
      radiusMaxPixels: 10,
      pickable: true,
    }),
  ];
}
